export const SUB_DAMAGE_LEVEL_BY_VALUE = {
  u_evento_averso: {
    index: 0,
    value: 'u_evento_adverso',
    title: 'Evento adverso',
    subtitle: 'Evento adverso - evitável.',
    description: 'Incidente que resulta em dano evitável a um paciente.'
  },
  u_reacao_adversa: {
    index: 1,
    value: 'u_reacao_adversa',
    title: 'Reação adversa',
    subtitle: 'Reação adversa - inevitável.',
    description: 'Dano inesperado e inevitável resultante de uma ação justificada em que foi seguido o processo correto para o contexto em que o incidente ocorreu.'
  }
} as const;

export type SubDamageLevel =
  typeof SUB_DAMAGE_LEVEL_BY_VALUE[keyof typeof SUB_DAMAGE_LEVEL_BY_VALUE];

export const getSubdamageLevel = ( value: string ): SubDamageLevel | undefined => {
  return Object.values(SUB_DAMAGE_LEVEL_BY_VALUE).find(
    item => item.value === value
  );
};

export const SUB_DAMAGE_LEVEL_LIST = Object.values(SUB_DAMAGE_LEVEL_BY_VALUE);

export const SUB_DAMAGE_LEVEL_OPTIONS = SUB_DAMAGE_LEVEL_LIST.map(item => ({
  label: item.subtitle,
  value: item.value
}));
